// An href this app routes itself, rather than one the browser navigates to. A router link keeps the former on
// the client; the latter has to be a plain anchor.
export const isInternalHref = (href: string): boolean => href.startsWith("/");

export const sleep = (ms = 1000) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const randomID = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${new Date().getTime()}${Math.random().toString(36).substring(2)}`;

export const copyToClipboard = async (str: string): Promise<boolean> =>
  navigator.clipboard
    .writeText(str)
    .then(
      () => true,
      () => false
    )
    .catch(() => false);

export const isMac =
  typeof navigator !== "undefined" && navigator.userAgent.includes("Mac");

export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const downloadTextAsFile = (
  text: string,
  filename: string = "download.txt",
  type = "text/plain"
) => {
  downloadBlob(new Blob([text], { type }), filename);
};

// Excel on Windows reads a CSV as the local codepage unless the file opens with a byte
// order mark, which turns characters like € into mojibake.
export const downloadCsvFile = (csv: string, filename: string) => {
  downloadTextAsFile(`\uFEFF${csv}`, filename, "text/csv;charset=utf-8");
};
